// The three answers a session probe can give (busy-my-web#26), in a module of their own so the
// interceptor's 401 handling (lib/sessionRenewal.js) can name them without importing
// auth.service — which imports the store, which imports the modules, which import the service
// layer, which imports the interceptor: an initialisation cycle for the sake of three strings.
// auth.service re-exports them, so every existing import keeps working.

/** `/bff/user` answered with real claims: the session is alive. */
export const SESSION_ACTIVE = 'active'
/** `/bff/user` answered 401: the only answer that actually means "signed out". */
export const SESSION_ENDED = 'ended'
/** We could not ask (5xx, offline, unreadable body): the session is neither proven nor gone. */
export const SESSION_UNKNOWN = 'unknown'
